import credit_android_mobile_1 from 'assets/images/success_page/credit_android_mobile_1.png';
import credit_android_native_1 from 'assets/images/success_page/credit_android_native_1.png';
import credit_ios_mobile_1 from 'assets/images/success_page/credit_ios_mobile_1.png';
import credit_ios_native_1 from 'assets/images/success_page/credit_ios_native_1.png';
import debit_android_mobile_1 from 'assets/images/success_page/debit_android_mobile_1.png';
import debit_android_native_1 from 'assets/images/success_page/debit_android_native_1.png';
import debit_ios_mobile_1 from 'assets/images/success_page/debit_ios_mobile_1.png';
import debit_ios_native_1 from 'assets/images/success_page/debit_ios_native_1.png';
import desktop_spotme from 'assets/images/success_page/desktop_spotme.png';

import { IS_ANDROID, IS_IOS } from 'consts/platformConsts';

import { IS_ANY_CB_PACT, IS_SPOT_ME_PACT } from 'utils/queryParamHelpers';

export function deviceCardImageSrc(isTablet, isEmbedded, showCreditDebitImage) {
  const isEnrolledInCredit = showCreditDebitImage || IS_ANY_CB_PACT;

  /** SpotMe Images  */
  if (IS_SPOT_ME_PACT) {
    return desktop_spotme;
  }

  /** CB Preorder Images */
  if (isEnrolledInCredit) {
    /** Native */
    if (isEmbedded) {
      if (IS_IOS) return credit_ios_native_1;
      if (IS_ANDROID) return credit_android_native_1;
    }

    /** Mobile */
    if (isTablet) {
      if (IS_IOS) return credit_ios_mobile_1;
      if (IS_ANDROID) return credit_android_mobile_1;
    }

    /** Desktop */
    return credit_ios_mobile_1;
  }

  /** Only Debit Images */

  /** Native */
  if (isEmbedded) {
    if (IS_IOS) return debit_ios_native_1;
    if (IS_ANDROID) return debit_android_native_1;
  }

  /** Mobile */
  if (isTablet) {
    if (IS_IOS) return debit_ios_mobile_1;
    if (IS_ANDROID) return debit_android_mobile_1;
  }

  /** Desktop */
  return debit_ios_mobile_1;
}
